import React, { useEffect, useState } from "react";
import "./feed-statistics-styles.scss";
import { useSelector } from "react-redux";
import { getReferences, getThread, getThreadFull } from "../../redux/selectors";
import { getFeedFilter } from "../../redux/selectors/feed-filter.selectors";
import { summaryService } from "../../api";
import { LoadingOutlined } from "@ant-design/icons";

type Props = {
  referencesFilter?: number[];
};
const FeedStat: React.FC<Props> = ({ referencesFilter }: Props) => {
  const thread = useSelector(getThread);
  const threadFull = useSelector(getThreadFull);
  const references = useSelector(getReferences);
  //const feedStatistics = useSelector(getFeedStatistics)
  const [postCount, setPostCount] = useState<any>({
    fb: 0,
    gs: 0,
    ig: 0,
    tg: 0,
    total: 0,
    tw: 0,
    vk: 0,
    yt: 0,
    dz: 0,
    ok: 0,
  });
  const currentFeedFilter = useSelector(getFeedFilter);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState();
  const [vk, setVk] = useState();
  const [tg, setTg] = useState();
  const [smi, setSmi] = useState();
  const [ok, setOk] = useState();
  const [yt, setYt] = useState();
  const [dz, setDz] = useState();

  useEffect(() => {
    setIsLoading(true);
    if (thread)
      summaryService
        .loadTrustDailyPosts({
          thread_id: window.location.pathname.includes("full")
            ? threadFull
            : thread?.id,
          from: currentFeedFilter.from,
          to: currentFeedFilter.to,
          filter: {
            referenceFilter: window.location.pathname.includes("full")
              ? []
              : window.location.pathname.includes("thread")
              ? references
              : referencesFilter,
            repostoption: "whatever",
            trustoption: currentFeedFilter.tonal,
            network_id:
              currentFeedFilter.networks.length > 0
                ? currentFeedFilter.networks
                : currentFeedFilter.network_id,
          },
        })
        .then((resp) => {
          setIsLoading(false);
          console.log("fffffff", calkSum(resp.total.total));
          setTotal(calkSum(resp.total.total));
          setVk(calkSum(resp.vk.total));
          setTg(calkSum(resp.tg.total));
          setSmi(calkSum(resp.gs.total));
          setOk(calkSum(resp.ok.total));
          setYt(calkSum(resp.yt.total));
          //setDz(calkSum(resp.dz.total));

          setPostCount(resp);
        })
        .catch((error) => {
          console.log(error);
        });
  }, [thread, referencesFilter, currentFeedFilter, references]);

  const calkSum = (arr: any) => {
    const sum = arr?.reduce((partialSum: any, a: any) => partialSum + a[1], 0);
    return sum;
  };

  let minusFilter = 0;

  return isLoading ? (
    <div className="feed-posts-loader">
      <LoadingOutlined />
    </div>
  ) : (
    <div className="feed-statistics">
      <div className="feed-statistics-item">
        <div className="feed-statistics-item__value">{total}</div>
        <div className="feed-statistics-item__desc">За период</div>
      </div>

      {currentFeedFilter.networks.length > 1 &&
      currentFeedFilter.networks.indexOf(1) != -1 ? (
        <div className="feed-statistics-item">
          <div className="feed-statistics-item__value">{vk}</div>
          <div className="feed-statistics-item__desc">Вконтакте</div>
        </div>
      ) : (
        ""
      )}
      {currentFeedFilter.networks.length > 1 &&
      currentFeedFilter.networks.indexOf(5) != -1 ? (
        <div className="feed-statistics-item">
          <div className="feed-statistics-item__value">{tg}</div>
          <div className="feed-statistics-item__desc">Telegram</div>
        </div>
      ) : (
        ""
      )}
      {currentFeedFilter.networks.length > 1 &&
      currentFeedFilter.networks.indexOf(8) != -1 ? (
        <div className="feed-statistics-item">
          <div className="feed-statistics-item__value">{yt}</div>
          <div className="feed-statistics-item__desc">YouTube</div>
        </div>
      ) : (
        ""
      )}
      {currentFeedFilter.networks.length > 1 &&
      currentFeedFilter.networks.indexOf(10) != -1 ? (
        <div className="feed-statistics-item">
          <div className="feed-statistics-item__value">{ok}</div>
          <div className="feed-statistics-item__desc">Одноклассники</div>
        </div>
      ) : (
        ""
      )}
      {currentFeedFilter.networks.length > 1 &&
      currentFeedFilter.networks.indexOf(4) != -1 ? (
        <div className="feed-statistics-item">
          <div className="feed-statistics-item__value">{smi}</div>
          <div className="feed-statistics-item__desc">СМИ</div>
        </div>
      ) : (
        ""
      )}

      {/* <div className="feed-statistics-item"> */}
      {/*  <div className="feed-statistics-item__value">{feedStatistics.attendance}</div> */}
      {/*  <div className="feed-statistics-item__desc">Аудитория</div> */}
      {/* </div> */}
    </div>
  );
};

export default FeedStat;
